import { tv } from 'tailwind-variants';

const baseLi = [
  'text-sm',
  'font-semibold',
  'uppercase',
  'leading-[1.125rem]',
  'tracking-[1px]',
  'text-grey-700'
];

export const breadcrumbVariants = tv({
  slots: {
    nav: [
      'flex',
      'justify-between',
      'bg-white',
      'px-6',
      'shadow-[inset_0_0_0_1px]',
      'shadow-grey-300',
      'lg:px-12'
    ],
    ol: ['flex', 'min-h-12', 'flex-wrap', 'items-center', 'py-1'],
    li: [
      ...baseLi,
      'truncate',
      'after:mx-4',
      'after:content-["/"]',
      'last:pointer-events-none',
      'last:cursor-default',
      'last:text-blue-400',
      'last:after:content-none',
      'last:max-w-[290px]',
      'last:lg:max-w-[250px]',
      'last:2xl:max-w-[400px]'
    ],
    button: baseLi
  }
});
